import { useContext } from "react";
import { SearchPowerUpsModalState } from "./SearchPowerUpsDropdown";
import StartFromPriorInternalSearchModal from "./StartFromPriorSearch/StartFromPriorInternalSearchModal";
import AutopilotCuratedInternalSearchContext from "../../../../contexts/AutopilotCuratedInternalSearchContext";

const InternalSearchPowerUps = ({
  modalState,
  setModalState,
}: {
  modalState: SearchPowerUpsModalState;
  setModalState: (modalState: SearchPowerUpsModalState) => void;
}) => {
  const { setSavedFilters } = useContext(AutopilotCuratedInternalSearchContext);

  return (
    <StartFromPriorInternalSearchModal
      isOpen={modalState === "startFromPriorSearch"}
      onClose={() => setModalState(null)}
      setSavedFilters={setSavedFilters}
    />
  );
};

export default InternalSearchPowerUps;
